import React from "react";
import Footer from "@/components/footer";
import WeatherMap from "@/components/weather-map";
import MainMenu from "@/components/main-menu";
import { Outlet } from "react-router-dom";

const MainLayout: React.FC = () => {
  return (
    <div className="h-screen flex flex-col relative">
      <div className="flex-1 flex relative overflow-hidden">
        <WeatherMap />
        <Outlet />
        <div className="absolute top-12 left-12 flex flex-col gap-4 z-20">
          <MainMenu />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
